import { Injectable } from '@angular/core';

import { Decimal } from 'decimal.js';

import { getPickPriceIds, isStartingPriceSelected, isXCastPick } from '../../picks/services/betslip-pick-helpers';
import { IBetslipCalculatorOverrides, ICalculatorBetslipInput } from '../models';
import { ComboSlipType, SingleSlipType } from '../slip-type';
import BaseInputBuilder, { BetslipStateInput, BetslipStateOverrides } from './base-input-builder';
import { getEditBetSlipId } from './slip.utils';

@Injectable()
export default class EditBetInputBuilder extends BaseInputBuilder {
    *getBetGeneratorInput(betslipState: BetslipStateInput): Iterable<ICalculatorBetslipInput> {
        const editMyBetState = betslipState.types.editBet;
        const stake = editMyBetState.earlyPayoutStake
            ? new Decimal(editMyBetState.earlyPayoutStake).add(new Decimal(editMyBetState.addedStake)).toNumber()
            : null;

        const items = Object.entries(editMyBetState.picks.pickState)
            .filter(([key, value]) => !value.isRemoved && !!editMyBetState.picks.pickList.find((p) => p.id.isEqual(key)))
            .map(([id, _]) => {
                const pick = editMyBetState.picks.pickList.find((p) => p.id.isEqual(id))!;

                return {
                    ...this.getPickInfo(pick),
                    eachWayInfo: null, // Each way is disabled in edit bet
                    isBanker: false,
                    isXCast: isXCastPick(pick),
                    isStartingPrice: isStartingPriceSelected(pick),
                };
            });

        if (editMyBetState.addPicksState.isVisible) {
            Array.prototype.push.apply(
                items,
                betslipState.types.editBet.addPicksState.pickList.map((pick) => ({
                    ...this.getPickInfo(pick),
                    eachWayInfo: null, // Each way is disabled in edit bet
                    isBanker: false,
                })),
            );
        }

        yield {
            slipId: getEditBetSlipId(),
            items,
            rewardToken: null,
            stake,
            system: items.length > 1 ? new ComboSlipType() : new SingleSlipType(),
        };
    }

    getEditBetSwapPickOverride(betslipState: BetslipStateOverrides): IBetslipCalculatorOverrides {
        const overrides: IBetslipCalculatorOverrides = {
            slipOverrides: [],
            pickOverrides: {
                prices: {},
                eachWay: {},
                replacements: {},
            },
        };
        const oldPick = betslipState.types.editBet.swapPickState.oldPick;
        const newPick = betslipState.types.editBet.swapPickState.newPick;
        if (oldPick !== null && newPick !== null) {
            overrides.pickOverrides.replacements![oldPick.id.toString()] = {
                pick: newPick,
                price: newPick.currentPrice || null,
                eachWayInfo: null, // EW not supported for swap
                isBanker: false, // Edit bet has no bankers
                priceIds: getPickPriceIds(newPick),
                isXCast: isXCastPick(newPick),
                isStartingPrice: isStartingPriceSelected(newPick),
            };
        }

        return overrides;
    }
}
